export default __webpack_public_path__ + "static/media/gold.d32b0589.svg";